import React, { useState } from 'react';
import TeamMemberEditorView from './team-member-editor-view';
import { createImage, updateImage } from '../../../utils/image/image-utils';

const TeamMemberEditorContainer = ({
  closeModal,
  id,
  teamMember: {
    displayed,
    error,
    isSaving,
    description,
    title,
    image,
    name,
  },
  onClickEdit,
  saveTeamMember,
  setDisplayed,
  setDescription,
  setName,
  setTitle,
  setPhoto,
  deleteTeamMember,
  fetchTeamMembers,
}) => {
  const [deleteError, setDeleteError] = useState(false);
  const [hasUnsavedImageChanges, setHasUnsavedImageChanges] = useState(false);

  const disabled = !name || !title || !description || hasUnsavedImageChanges;

  const handleChangeDisplayed = (e) => {
    setDisplayed(e.target.checked);
  };

  const handleClickSave = () => {
    saveTeamMember();
  };

  const onRemovePhoto = () => {
    setPhoto({});
  };

  const onCreatePhoto = async (photo) => {
    try {
      const res = await createImage(photo);
      setPhoto(res);
      return res;
    } catch (e) {
      console.error('error creating image: ', e);
      throw e;
    }
  };

  const onChangePhoto = async (photo) => {
    try {
      const res = await updateImage(photo);
      setPhoto(res);
      return res;
    } catch (e) {
      console.error('error updating image: ', e);
      throw e;
    }
  };

  const handleClickDelete = () => {
    if (window.confirm('Are you sure you want to delete this team member?')) {
      deleteTeamMember()
        .then((res) => {
          if (res) {
            setDeleteError(true);
          } else {
            setDeleteError(false);
            closeModal();
            fetchTeamMembers();
          }
        });
    }
  };

  return (
    <TeamMemberEditorView
      closeModal={closeModal}
      saveDisabled={disabled}
      displayed={displayed}
      error={error}
      id={id}
      isSaving={isSaving}
      onChangeDisplayed={handleChangeDisplayed}
      onClickEdit={onClickEdit}
      onClickSave={handleClickSave}
      setDescription={setDescription}
      setTitle={setTitle}
      setName={setName}
      description={description}
      title={title}
      image={image}
      onRemovePhoto={onRemovePhoto}
      onCreatePhoto={onCreatePhoto}
      onChangePhoto={onChangePhoto}
      onClickDelete={handleClickDelete}
      name={name}
      deleteError={deleteError}
      onImageChangesStatusChange={setHasUnsavedImageChanges}
      hasUnsavedImageChanges={hasUnsavedImageChanges}
    />
  );
};

export default TeamMemberEditorContainer;
